import React, { useState, useEffect } from 'react';
import RichTable from '../components/richTable/RichTable.jsx';
import tableHelpers from '../helpers/TableHelpers.js';

function PlanSizing(props) {

    const [algos, setAlgos] = useState([]);
    const [planTrades, setPlanTrades] = useState([]);

    useEffect(() => {
        (async function () {
            let text = await (await fetch(`/api/algos?planId=` + props.planId + `&years=` + 10)).json();
            setAlgos(text);

            let algos = "";
            text.forEach(a => {
                algos += a.idalgos + ",";
            })
            let endDate = new Date();
            let startDate = new Date(2014, 0, 1)
            const query = `/api/backtestTrades?algos=` + algos +
                "&startDate=" + startDate.toLocaleDateString() +
                "&endDate=" + endDate.toLocaleDateString();
            let trades = await (await fetch(query)).json();
            console.log("Retrieved " + trades.length + " trades", trades);
            setPlanTrades(trades);

        })();
    }, [props.planId]);

    function getTrades() {
        return planTrades.map(t => {
            let algo = algos.find(a => a.idalgos === t.algoId);
            return {
                ...t,
                algoName: algo ? algo.display_name : t.algoId,
                symbol: algo ? algo.trade_symbol : ""
            };
        });
    }

    return (
        <>
            <div style={{ padding: '20px' }}>
                <RichTable
                    data={getTrades()}
                    className="table-striped table-hover table-condensed fixed"
                    enableExport={true}
                    mappers={[
                        { title: 'Algo ID', field: 'algoId', sorters: true, filter: 'text' },
                        { title: 'Algo', field: 'algoName', sorters: true, filter: 'text' },
                        { title: 'Symbol', field: 'symbol', sorters: true, filter: 'text' },
                        { title: 'Purchase Date', field: 'purchase_date', formatter: tableHelpers.dateFormmatter, sorters: true },
                        { title: 'Purchase Price', field: 'purchase_price', formatter: tableHelpers.moneyFormatter, sorters: true },
                        { title: 'Sell Date', field: 'sell_date', formatter: tableHelpers.dateFormmatter, sorters: true },
                        { title: 'Sell Price', field: 'sell_price', formatter: tableHelpers.moneyFormatter, sorters: true },
                        { title: 'Profit', field: 'profit', formatter: tableHelpers.percentFormatter, sorters: true }
                    ]}
                />
            </div>
        </>
    );
}

export default PlanSizing;
